// components/DisplayRow.jsx
import React from "react";

function DisplayRow({ label, value }) {
  return (
    <div className="profile-field-row">
      <div className="profile-field-label">{label}</div>
      <div className="profile-field-value-wrapper">
        <div className="profile-field-value">{value}</div>
        <div className="profile-field-underline" />
      </div>
    </div>
  );
}

export default DisplayRow;